import { bindRequestLogic } from './utils'
import Types from '../actionTypes/companyCategory'
import { companyCategoryAPI } from '../api'
import { mapCompanyCategoryDetail } from '../mapping/roles'

const getCompanyCategories = bindRequestLogic({
  clientFunc: companyCategoryAPI.getCompanyCategories,
  type: Types.GET_COMPANY_CATEGORIES_REQUEST,
  successType: Types.GET_COMPANY_CATEGORIES_SUCCESS,
  failType: Types.GET_COMPANY_CATEGORIES_FAILED,
  isQueryParam: true
})

const getCompanyCategory = bindRequestLogic({
  clientFunc: companyCategoryAPI.getCompanyCategory,
  type: Types.GET_COMPANY_CATEGORY_REQUEST,
  successType: Types.GET_COMPANY_CATEGORY_SUCCESS,
  failType: Types.GET_COMPANY_CATEGORY_FAILED,
  modelName: 'companyCategory',
  mapResponse: mapCompanyCategoryDetail
})

const updateCompanyCategory = bindRequestLogic({
  clientFunc: companyCategoryAPI.updateCompanyCategory,
  type: Types.UPDATE_COMPANY_CATEGORY_REQUEST,
  successType: Types.UPDATE_COMPANY_CATEGORY_SUCCESS,
  failType: Types.UPDATE_COMPANY_CATEGORY_FAILED
})

const addCompanyCategoryTranslation = bindRequestLogic({
  clientFunc: companyCategoryAPI.addCompanyCategoryTranslation,
  type: Types.ADD_COMPANY_CATEGORY_TRANSLATION_REQUEST,
  successType: Types.ADD_COMPANY_CATEGORY_TRANSLATION_SUCCESS,
  failType: Types.ADD_COMPANY_CATEGORY_TRANSLATION_FAILED
})

const updateCompanyCategoryTranslation = bindRequestLogic({
  clientFunc: companyCategoryAPI.updateCompanyCategoryTranslation,
  type: Types.UPDATE_COMPANY_CATEGORY_TRANSLATION_REQUEST,
  successType: Types.UPDATE_COMPANY_CATEGORY_TRANSLATION_SUCCESS,
  failType: Types.UPDATE_COMPANY_CATEGORY_TRANSLATION_FAILED
})

const deleteCompanyCategoryTranslation = bindRequestLogic({
  clientFunc: companyCategoryAPI.deleteCompanyCategoryTranslation,
  type: Types.DELETE_COMPANY_CATEGORY_TRANSLATION_REQUEST,
  successType: Types.DELETE_COMPANY_CATEGORY_TRANSLATION_SUCCESS,
  failType: Types.DELETE_COMPANY_CATEGORY_TRANSLATION_FAILED
})

const getSystemCompanyCategories = bindRequestLogic({
  clientFunc: companyCategoryAPI.getSystemCompanyCategories,
  type: Types.GET_SYSTEM_COMPANY_CATEGORIES_REQUEST,
  successType: Types.GET_SYSTEM_COMPANY_CATEGORIES_SUCCESS,
  failType: Types.GET_SYSTEM_COMPANY_CATEGORIES_FAILED,
  isQueryParam: true
})

export default [
  getCompanyCategories,
  getCompanyCategory,
  updateCompanyCategory,
  addCompanyCategoryTranslation,
  updateCompanyCategoryTranslation,
  deleteCompanyCategoryTranslation,
  getSystemCompanyCategories
]
